@let isMobile = breakpoints() === "mobile";
<nav [ngClass]="{ 'is-banner-displayed': isPromotionBanner() && isPromotionAllowed() }" class="nav-wrapper">
  @if (dataNavigation$ | async; as dataNavigation) {
    <div
      [class.nav-scroll]="isScroll()"
      [style.background-color]="
        isOpen()
          ? (style().menuBackgroundColor | color)
          : isScroll() && style().backgroundColor === 'TRANSPARENT'
            ? ('WHITE' | color)
            : (style().backgroundColor | color)
      "
      class="nav">
      <div class="row container nav-container">
        <div class="col-xs-6 col-lg-8">
          <div class="flex align-items--center row">
            <app-menu-burger
              (isOpenChange)="onOpen($event)"
              [centered]="isMobile"
              [color]="isOpen() ? style().menuTextColor : isScroll() ? 'BLACK' : style().textColor"
              [isOpen]="isOpen()"
              [size]="isMobile ? 'SMALL' : 'NORMAL'"
              [withText]="!isMobile"
              class="col-lg-6" />
            <a
              (click)="onOpen(false)"
              aria-label="Perene"
              class="col-lg-6 center-lg flex align-items--center"
              [routerLink]="dataNavigation.logoUrl?.[0]?.url || routeToHomepage">
              <svg
                [attr.fill]="
                  isOpen() ? (style().menuTextColor | color) : isScroll() ? 'black' : (style().textColor | color)
                "
                aria-label="Perene"
                class="logo"
                viewBox="0 0 424.2 95">
                <path
                  d="M69.4 50.2V11c0-2.4.8-4.1 2.5-4.3 3-.5 5.3-.4 6.6 2l.7 1.2c1.1 2 1.9 2.4 4.1 1.6l7.5-3.1c6.6-2.7 13.4-3.2 20.2-1.3 6.7 1.9 10.5 7.2 10.5 14.2v30.1c.2 8.2-4.6 13.9-12.7 15.3-6.8 1.2-13.4.4-19.8-2.5l-5.7-2.3c-2.3-.7-3-.1-3 2.2v24.8c0 2-.4 3.9-2.4 4.7-2.2 1-4.6 1-6.8-.4-1.3-.9-1.8-2.2-1.8-3.8V49.9Zm41.4-13.5V23.5c0-4.5-3-7.5-7.5-7.5H87.8c-4.4 0-7.4 3-7.4 7.5v26.3c0 4.5 3 7.5 7.5 7.6h15.4c4.6 0 7.6-3 7.6-7.6v-13Zm146 4.3v10.3c.3 3.5 2.6 5.6 6.2 6h2.7c0 .1 27.3.1 27.3.1 4.8 0 5.5 3 4.9 6.6-.3 1.6-2 2.8-3.8 2.8-8 0-26.5.2-34.5 0-7.2-.2-13.6-7-13.6-14.2V20.4c0-6 4.7-11.5 11-13.2 1.4-.4 3-.6 4.4-.6H284c6.7.3 12.6 5.5 13.9 12 .1.7.2 1.4.2 2v11.9c0 5.6-2.8 8.5-8.5 8.5h-32.7Zm30.3-8.8c0-3.1-.1-6.2 0-9.2.2-4.1-2.9-6.9-6.9-6.9h-16.5c-4.3 0-7 2.7-7 7v9.1h30.4Zm95.8 8.8v10.2c.2 3.5 2.6 5.9 6.2 6.1l11.6.2h18.7c4.8 0 5.5 3.9 4.4 7.1-.5 1.6-2 2.3-3.6 2.3-8 0-26.5.2-34.5 0-6.9-.2-13.4-6.7-13.5-13.6-.2-11.2-.3-22.3 0-33.4.2-6 4-9.9 9.3-12 1.9-.7 4-1.1 6-1.2 7.4 0 14.9-.2 22.3 0s14.6 6.3 14.4 14.9v11.1c0 5.4-2.9 8.3-8.3 8.3h-33Zm0-8.9h30.4v-9.4c0-3.9-2.7-6.6-6.5-6.7h-17.5c-3.2 0-6.1 2.2-6.3 5.2-.3 3.6 0 7.2 0 10.8ZM143.5 41V50.6c0 3.9 2.3 6.4 6.2 6.7h2.6c0 .1 27.5.1 27.5.1 4.7 0 5.6 3.6 4.6 6.8-.5 1.7-1.9 2.6-3.6 2.6-8.1 0-26.6.2-34.7 0-7.1-.2-13.4-7-13.4-14.1V20.4c0-5.9 4.6-11.5 10.9-13.1 1.5-.4 3-.6 4.6-.6h22.4c6.5.3 12.4 5.2 13.9 11.5 0 .4.2.8.2 1.3 0 4.9.2 9.8 0 14.7-.1 4-2.9 6.6-6.9 6.9H143.7Zm0-8.9h30.3c0-3.2-.1-6.4 0-9.5.2-3.2-2.4-6.5-6.4-6.6h-17.7c-3.2 0-6 2.3-6.2 5.1-.2 3.6 0 7.2 0 10.9Zm165.4 4.3v-25c0-.6 0-1.3.1-1.9.3-1.6 1.4-2.6 3-2.8h2.8c1.3 0 2.3.7 3 1.8l1 1.8c1.1 1.8 1.8 2.2 3.8 1.5l8-3.2c6.5-2.6 13.1-3.1 19.9-1.2 6.6 1.8 10.7 7.2 10.7 14.1v40.8c0 3-1.8 4.7-4.7 4.8h-2.1c-2.1 0-3.8-1.7-4.1-3.8V23.9c0-4.9-3.7-7.9-7.8-7.8h-14.9c-4 0-7.9 2.8-7.8 7.8V62c0 3.2-1.6 4.9-4.9 4.9H313c-2 0-3.7-1.6-4-3.6V36.4Zm-113.3.1V10.8c0-2.9 1.3-4.1 4.2-4.2 2.5-.1 4.3.7 5.4 3 1.4 3 2.9 2.8 5.2 1.3 2.7-1.8 5.4-3.6 8.7-4.1 1.1-.1 2.2-.2 3.3-.2h12.9c4.2 0 5.5 2.3 5 6.1-.2 1.7-1.6 3-3.4 3.3h-22.4c-1.8 0-3.6.3-5.1 1.4-2 1.5-2.9 3.5-2.9 6v38c0 1 0 2-.5 2.9-.7 1.7-2.1 2.5-4 2.5-2.3 0-4.7.2-5.9-2.3-.4-.7-.5-1.7-.5-2.5V36.4ZM41.4 5.6c0 .3-.1.9-.3 1.5L19.3 68l-8.4 23.5c-1.1 3.1-3.3 4.1-6.4 3.1l-.8-.3C.6 93.2-.6 90.9.5 87.7l7.2-20.3 22.9-64c1-2.8 3.4-4 6.3-3l1.7.6c1.9.8 2.9 2.3 2.9 4.6Z" />
              </svg>
            </a>
          </div>
        </div>
        <div class="col-xs-6 end-xs col-lg-4">
          <div class="nav-actions">
            @if (ctaSecondary() && !isMobile) {
              <app-button
                (click)="onCustomerAreaClick()"
                [label]="ctaSecondary().label"
                [size]="'NORMAL'"
                [theme]="isOpen() ? 'TRANSPARENT_WHITE' : isScroll() ? 'TRANSPARENT_BLACK' : ctaSecondary().theme"
                [url]="ctaSecondary().url ?? ''" />
            }
            @if (cta() && (!isMobile || !isOpen())) {
              <app-button
                (click)="onCtaClick()"
                [label]="cta().label"
                [size]="isMobile ? 'SMALL' : 'NORMAL'"
                [theme]="isOpen() ? 'FULL_WHITE' : isScroll() ? (ctaSecondary() ? 'BLUE' : 'WHITE') : cta().theme"
                [url]="ctaAnchor() ? '' : (cta().url ?? '')" />
            }
          </div>
        </div>
      </div>
      <div
        [class.nav-modal--open]="isOpen()"
        [style.--link-opacity]="style().menuLinkOpacity"
        [style.--primary-count]="dataNavigation.links.primary.length"
        [style.background-color]="style().menuBackgroundColor | color"
        [style.color]="style().menuTextColor | color"
        class="nav-modal">
        @if (isMobile) {
          <span aria-hidden="true" class="nav-modal-spacer nav-modal-spacer--top"></span>
        }
        @for (
          links of [dataNavigation.links.primary, dataNavigation.links.secondary];
          track links;
          let first = $first;
          let last = $last
        ) {
          <ul class="list">
            @for (link of links; track link) {
              <li [class.list-item-first]="first" class="list-item">
                <a
                  (click)="onOpen(false)"
                  [routerLinkActive]="'link--active'"
                  [routerLinkActiveOptions]="{ exact: link.url === '/' }"
                  [routerLink]="link.url"
                  class="link"
                  dynamicUrl>
                  {{ link.label }}
                </a>
              </li>
              @if (link.hasSeparator) {
                <hr />
              }
            }
            @if (last) {
              <li>
                <div class="list-item-social">
                  @if (dataNavigation.socialNetworks) {
                    <app-social-networks [items]="dataNavigation.socialNetworks" [style]="socialNetworksStyle()" />
                  }
                </div>
              </li>
            }
          </ul>
          @if (first && isMobile && cta()) {
            <div class="nav-modal-actions">
              <app-button
                (click)="onCtaClick()"
                [label]="cta().label"
                [size]="'NORMAL'"
                [theme]="'FULL_WHITE'"
                [url]="ctaAnchor() ? '' : (cta().url ?? '')" />
              @if (ctaSecondary()) {
                <app-button
                  (click)="onCustomerAreaClick()"
                  [label]="ctaSecondary().label"
                  [size]="'NORMAL'"
                  [theme]="'TRANSPARENT_WHITE'"
                  [url]="ctaSecondary().url ?? ''" />
              }
            </div>
            <span aria-hidden="true" class="nav-modal-spacer"></span>
          }
        }
      </div>
    </div>
  }
</nav>
